// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EditItemWithPathLocalDatagramBuf } from '../local/edit-item-with-path-local-datagram-buf.js';
import { GuestLoginLocalDatagramBuf } from '../local/guest-login-local-datagram-buf.js';
import { GuestLogoutLocalDatagramBuf } from '../local/guest-logout-local-datagram-buf.js';
import { LoginLocalDatagramBuf } from '../local/login-local-datagram-buf.js';
import { LogoutLocalDatagramBuf } from '../local/logout-local-datagram-buf.js';
import { UploadItemsWithPathLocalDatagramBuf } from '../local/upload-items-with-path-local-datagram-buf.js';


export class LocalDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):LocalDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsLocalDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:LocalDatagramBuf):LocalDatagramBuf {
  return (obj || new LocalDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsLocalDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:LocalDatagramBuf):LocalDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new LocalDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

login(obj?:LoginLocalDatagramBuf):LoginLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new LoginLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

logout(obj?:LogoutLocalDatagramBuf):LogoutLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new LogoutLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

guestLogin(obj?:GuestLoginLocalDatagramBuf):GuestLoginLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new GuestLoginLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

guestLogout(obj?:GuestLogoutLocalDatagramBuf):GuestLogoutLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new GuestLogoutLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

uploadItemsWithPath(obj?:UploadItemsWithPathLocalDatagramBuf):UploadItemsWithPathLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new UploadItemsWithPathLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

editItemWithPath(obj?:EditItemWithPathLocalDatagramBuf):EditItemWithPathLocalDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new EditItemWithPathLocalDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startLocalDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(6);
}

static addLogin(builder:flatbuffers.Builder, loginOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, loginOffset, 0);
}

static addLogout(builder:flatbuffers.Builder, logoutOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, logoutOffset, 0);
}

static addGuestLogin(builder:flatbuffers.Builder, guestLoginOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, guestLoginOffset, 0);
}

static addGuestLogout(builder:flatbuffers.Builder, guestLogoutOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, guestLogoutOffset, 0);
}

static addUploadItemsWithPath(builder:flatbuffers.Builder, uploadItemsWithPathOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, uploadItemsWithPathOffset, 0);
}

static addEditItemWithPath(builder:flatbuffers.Builder, editItemWithPathOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, editItemWithPathOffset, 0);
}

static endLocalDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
